// extracted by mini-css-extract-plugin
module.exports = {"generalAccess":"SharePrivacy_generalAccess__2QREN","sectionLabel":"SharePrivacy_sectionLabel__MqXU3"};